class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.headerSection = document.querySelector('.shopify-section-header');

    if (this.headerSection) {
      this.headerWrap = this.headerSection.querySelector('.header-wrapper');
      this.background = this.headerWrap ? this.headerWrap.getAttribute('data-background') : null;
      this.isFrosted = this.headerWrap ? this.headerWrap.dataset.frosted : null;
    }

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    // Capture phase so Searchanise/Snize cannot open its mobile panel first
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this),
      true
    );

    // Prevent native <details> toggle on search (mobile uses custom bar)
    this.detailsContainer.addEventListener('toggle', () => {
      if (this.isHeaderSearchMobile()) {
        this.detailsContainer.removeAttribute('open');
      }
    });

    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');

    this.onMobileSearchBodyClick = this.onMobileSearchBodyClick.bind(this);
    this.onMobileSearchKeyup = (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.closeMobileSearch();
    };

    this.lockLegacyModalInputs();
    this.initSnizeMobileBlocker();
  }

  getMobileSearch() {
    return document.getElementById('HeaderMobileSearch');
  }

  isHeaderSearchMobile() {
    return (
      this.classList.contains('header__search') &&
      window.matchMedia('(max-width: 768px)').matches
    );
  }

  hideSnizeMobilePanel() {
    document.querySelectorAll(
      '.snize-mobile-top-panel, .snize-mobile-overlay, .snize_mobile_overlay, #snize_mobile_overlay, [class*="snize-mobile-top"]'
    ).forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('hidden', '');
      el.classList.remove('snize-mobile-top-panel--active', 'is-active', 'active', 'open');
    });

    document.querySelectorAll(
      '.snize-mobile-top-panel input, .snize-input-style, input[id*="snize"]'
    ).forEach((el) => {
      try { el.blur(); } catch (e) {}
    });

    document.documentElement.classList.remove('snize-mobile-open');
    document.body.classList.remove('snize-mobile-open', 'snize-no-scroll');
  }

  alignSnizeSuggestions() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    if (!document.body.classList.contains('mobile-search-open')) return;

    const pill = document.querySelector('#HeaderMobileSearch .header-mobile-search__pill');
    const results = document.querySelector('.snize-ac-results');
    if (!pill || !results) return;

    const rect = pill.getBoundingClientRect();
    const top = Math.round(rect.bottom + 8);
    const left = Math.round(rect.left);
    const width = Math.round(rect.width);

    results.style.setProperty('position', 'fixed', 'important');
    results.style.setProperty('top', `${top}px`, 'important');
    results.style.setProperty('left', `${left}px`, 'important');
    results.style.setProperty('width', `${width}px`, 'important');
    results.style.setProperty('right', 'auto', 'important');
    results.style.setProperty('margin', '0', 'important');
    results.style.setProperty('transform', 'none', 'important');
    results.style.setProperty('max-width', 'none', 'important');
    results.style.setProperty('z-index', '1000', 'important');
  }

  initSnizeMobileBlocker() {
    if (!this.classList.contains('header__search')) return;

    const isSnizeNode = (node) => {
      if (!node || node.nodeType !== 1) return false;
      const id = node.id ? String(node.id).toLowerCase() : '';
      const className = typeof node.className === 'string' ? node.className.toLowerCase() : '';
      if (id.includes('snize') || className.includes('snize-mobile')) return true;
      return !!(node.matches && node.matches('.snize-mobile-top-panel, [class*="snize-mobile-top"], .snize-ac-results'));
    };

    const observer = new MutationObserver((mutations) => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      let shouldAlign = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (isSnizeNode(node) || (node.querySelector && node.querySelector('.snize-mobile-top-panel, [class*="snize-mobile-top"], .snize-ac-results'))) {
              this.hideSnizeMobilePanel();
              shouldAlign = true;
            }
          }
        } else if (isSnizeNode(mutation.target)) {
          this.hideSnizeMobilePanel();
          shouldAlign = true;
        }
      }

      if (shouldAlign || document.querySelector('.snize-ac-results')) {
        requestAnimationFrame(() => this.alignSnizeSuggestions());
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    document.addEventListener('focusin', (event) => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      const target = event.target;
      if (!target) return;
      if (
        target.closest('.snize-mobile-top-panel') ||
        (target.classList && target.classList.contains('snize-input-style')) ||
        (target.id && String(target.id).toLowerCase().includes('snize'))
      ) {
        this.hideSnizeMobilePanel();
        const mobileInput = document.getElementById('Search-In-Mobile');
        if (mobileInput && document.body.classList.contains('mobile-search-open')) {
          mobileInput.focus({ preventScroll: true });
        }
      }
    }, true);

    window.addEventListener('resize', () => this.alignSnizeSuggestions(), { passive: true });
    window.addEventListener('scroll', () => this.alignSnizeSuggestions(), { passive: true });
  }

  lockLegacyModalInputs() {
    if (!this.classList.contains('header__search')) return;

    const setLocked = (locked) => {
      this.querySelectorAll('.search-modal input, .search-modal button').forEach((el) => {
        if (el.type === 'hidden') return;
        if (locked) {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('disabled', '');
        } else {
          el.removeAttribute('tabindex');
          el.removeAttribute('disabled');
        }
      });
    };

    const apply = () => setLocked(window.matchMedia('(max-width: 768px)').matches);
    apply();
    window.matchMedia('(max-width: 768px)').addEventListener('change', apply);
  }

  isOpen() {
    const mobileSearch = this.getMobileSearch();
    if (this.isHeaderSearchMobile() && mobileSearch) {
      return mobileSearch.classList.contains('is-open');
    }
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Mobile header search: only use the in-flow bar under the logo
    if (this.isHeaderSearchMobile()) {
      this.hideSnizeMobilePanel();
      const mobileSearch = this.getMobileSearch();
      if (!mobileSearch) return;
      this.isOpen() ? this.closeMobileSearch() : this.openMobileSearch();
      return;
    }

    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  onMobileSearchBodyClick(event) {
    const mobileSearch = this.getMobileSearch();
    if (!mobileSearch) return;

    if (
      mobileSearch.contains(event.target) ||
      this.summaryToggle.contains(event.target) ||
      event.target.closest('.snize-ac-results')
    ) {
      return;
    }
    this.closeMobileSearch();
  }

  openMobileSearch() {
    const mobileSearch = this.getMobileSearch();
    if (!mobileSearch) return;

    this.hideSnizeMobilePanel();

    // Force-close legacy modal so it cannot steal focus or paint above the logo
    this.detailsContainer.removeAttribute('open');
    this.querySelectorAll('.search-modal input:not([type="hidden"])').forEach((el) => {
      el.blur();
      el.setAttribute('disabled', '');
      el.setAttribute('tabindex', '-1');
    });

    mobileSearch.hidden = false;
    mobileSearch.classList.add('is-open');
    mobileSearch.removeAttribute('hidden');
    document.body.classList.add('mobile-search-open');
    this.summaryToggle.setAttribute('aria-expanded', 'true');

    document.addEventListener('keyup', this.onMobileSearchKeyup);
    setTimeout(() => {
      document.addEventListener('click', this.onMobileSearchBodyClick);
    }, 0);

    const input = mobileSearch.querySelector('#Search-In-Mobile');
    if (input) {
      input.removeAttribute('tabindex');
      if (!input.dataset.snizeAlignBound) {
        input.dataset.snizeAlignBound = 'true';
        input.addEventListener('input', () => {
          setTimeout(() => this.alignSnizeSuggestions(), 50);
          setTimeout(() => this.alignSnizeSuggestions(), 200);
        });
      }
      // Focus after layout so caret stays inside the lower pill
      setTimeout(() => {
        this.hideSnizeMobilePanel();
        input.focus({ preventScroll: true });
        this.hideSnizeMobilePanel();
        this.alignSnizeSuggestions();
      }, 50);
      setTimeout(() => this.hideSnizeMobilePanel(), 200);
      setTimeout(() => this.hideSnizeMobilePanel(), 500);
    }
  }

  closeMobileSearch(focusToggle = true) {
    const mobileSearch = this.getMobileSearch();
    if (!mobileSearch) return;

    const input = mobileSearch.querySelector('#Search-In-Mobile');
    if (input) {
      input.blur();
      input.value = '';
      input.setAttribute('tabindex', '-1');
    }

    mobileSearch.classList.remove('is-open');
    mobileSearch.hidden = true;
    mobileSearch.setAttribute('hidden', '');
    document.body.classList.remove('mobile-search-open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    this.detailsContainer.removeAttribute('open');

    document.removeEventListener('click', this.onMobileSearchBodyClick);
    document.removeEventListener('keyup', this.onMobileSearchKeyup);

    if (focusToggle) this.summaryToggle.focus();
  }

  open(event) {
    // Safety: never open legacy modal on mobile header search
    if (this.isHeaderSearchMobile()) {
      this.openMobileSearch();
      return;
    }

    if (this.classList.contains('header__search')) {
      if (this.isFrosted && this.headerWrap) this.headerWrap.classList.remove('frosted-header-glass');
      if (this.headerSection && this.background) {
        this.headerSection.classList.add(this.background, 'is-filled');
      }
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.summaryToggle.setAttribute('aria-expanded', 'true');

    const container = this.detailsContainer.querySelector('[tabindex="-1"]');
    const input =
      this.detailsContainer.querySelector('input[name="q"]') ||
      this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (container) {
      trapFocus(container, input);
    } else if (input) {
      input.focus();
    }
  }

  close(focusToggle = true) {
    if (this.isHeaderSearchMobile() || document.body.classList.contains('mobile-search-open')) {
      this.closeMobileSearch(focusToggle);
      return;
    }

    if (this.classList.contains('header__search')) {
      if (this.isFrosted && this.headerWrap) this.headerWrap.classList.add('frosted-header-glass');
      if (this.headerSection && this.background) {
        this.headerSection.classList.remove(this.background, 'is-filled');
      }
    }

    const searchInput =
      this.querySelector('input[name="q"]') || this.querySelector('input[type="search"]');
    const predictiveSearch = this.querySelector('predictive-search');

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.summaryToggle.setAttribute('aria-expanded', 'false');

    if (searchInput) {
      searchInput.value = '';
      searchInput.setAttribute('aria-activedescendant', '');
      searchInput.setAttribute('aria-expanded', false);
    }

    if (predictiveSearch) {
      const selected = predictiveSearch.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      predictiveSearch.removeAttribute('results');
      predictiveSearch.removeAttribute('open');
    }
  }
}

customElements.define('details-modal', DetailsModal);
